import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-shovel-graph-popup',
  templateUrl: './shovel-graph-popup.component.html',
  styleUrls: ['./shovel-graph-popup.component.scss']
})
export class ShovelGraphPopupComponent implements OnInit {
EquipmentId:number;
  constructor(@Inject(MAT_DIALOG_DATA) private _data: any, public dialogRef: MatDialogRef<ShovelGraphPopupComponent>) { }

  ngOnInit(): void {
    this.EquipmentId= this._data.equipmentId;
  }

}
